// Types
import type { TAutomatedEmailTriggerVariant } from '~/modules/opportunities/automated-email/services/trigger-variant/types';

export class AutomatedEmailTriggerVariantService {
  static resolve(trigger: string): TAutomatedEmailTriggerVariant {
    const normalizedTrigger: string = trigger.toLowerCase();

    if (normalizedTrigger.includes('withdrawn')) {
      return 'withdrawn';
    }

    return normalizedTrigger.includes('reduced') ? 'reduced' : 'market-success';
  }
}
